module.exports = __webpack_public_path__ + "img/Weapon_77.77fe6866.png";